import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import PolicyUpdate from './components/PolicyUpdate';
import Contact from './components/Contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container, Button, NavItem } from 'react-bootstrap';
import ManageGroupCodes from './components/ManageGroupCodes';
import ListOrganization from './components/ListOrganization';
import Logout from './components/Logout';
import { FaTachometerAlt, FaUsers, FaPlusCircle } from 'react-icons/fa';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const toTitleCase = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Router>
      <div>
        <Navbar bg="light" expand="lg" style={{ fontSize: '1.2rem', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <Container fluid>
            <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
              <img
                src="/sonde-logo.png"
                alt="Sonde"
                height="36"
                className="d-inline-block align-middle"
                style={{ marginRight: '10px' }}
              />
              <span style={{ fontWeight: 600, fontSize: '1.3rem', color: '#2c3e50' }}>Admin Portal</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/" style={{ marginRight: '10px' }}>Home</Nav.Link>
                <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
              </Nav>
              <Nav className="align-items-center">
                {user ? (
                  <>
                    <span className="navbar-text me-3" style={{ fontSize: '1rem', color: '#34495e' }}>
                      {user.email} <span style={{ color: '#888' }}>({toTitleCase(user.environment || 'unknown')})</span>
                    </span>
                    <Logout user={user} setUser={setUser} />
                  </>
                ) : (
                  <Button variant="outline-primary" as={Link} to="/login">Login</Button>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
      <div className="App" style={{ display: 'flex', minHeight: 'calc(100vh - 64px)' }}>
        {user && (
          <div
            className="side-nav"
            style={{
              width: '260px',
              padding: '24px 16px',
              minHeight: 'calc(100vh - 64px)',
              textAlign: 'left',
              fontSize: '1.1rem',
              borderRight: '1px solid #eee',
              background: '#f8fafc',
              boxShadow: '2px 0 8px rgba(0,0,0,0.03)',
              borderRadius: '0 16px 16px 0',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px'
            }}
          >
            <Nav className="flex-column" style={{ gap: '12px' }}>
              <NavItem>
                <Nav.Link
                  as={Link}
                  to="/list-organization"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    color: '#34495e',
                    fontWeight: 500,
                    transition: 'background 0.2s, color 0.2s'
                  }}
                  activeclassname="active"
                  className="side-nav-link"
                >
                  <FaTachometerAlt style={{ color: '#2980b9' }} />
                  Sonde App Dashboard
                </Nav.Link>
              </NavItem>
              <NavItem>
                <Nav.Link
                  as={Link}
                  to="/manage-group"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    color: '#34495e',
                    fontWeight: 500,
                    transition: 'background 0.2s, color 0.2s'
                  }}
                  activeclassname="active"
                  className="side-nav-link"
                >
                  <FaUsers style={{ color: '#27ae60' }} />
                  Manage Group Codes
                </Nav.Link>
              </NavItem>
              <NavItem>
                <Nav.Link
                  as={Link}
                  to="/create-organization"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    color: '#34495e',
                    fontWeight: 500,
                    transition: 'background 0.2s, color 0.2s'
                  }}
                  activeclassname="active"
                  className="side-nav-link"
                >
                  <FaPlusCircle style={{ color: '#e67e22' }} />
                  Create Organization
                </Nav.Link>
              </NavItem>
            </Nav>
          </div>
        )}
        <div style={{ flex: 1, minHeight: 'calc(100vh - 64px)' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={user ? <Home /> : <Login onLogin={handleLogin} />} />
            <Route path="/list-organization" element={<ListOrganization />} />
            <Route path="/manage-group" element={<ManageGroupCodes />} />
            <Route path="/create-organization" element={<CreateOrganization />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

function Home() {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      minHeight: 'calc(100vh - 64px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: 'url(/hca.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}>
      {/* You can add a welcome message or leave it empty */}
      {/* <h1 style={{ color: '#fff', background: 'rgba(0,0,0,0.3)', padding: '20px 40px', borderRadius: '8px' }}>Welcome to Sonde Portal</h1> */}
    </div>
  );
}

function CreateOrganization() {
  return <img src="/work-in-progress.png" alt="Work in Progress" style={{ width: '30%', height: 'auto' }} />;
}

export default App;